import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type GoogleDriveConnectionStatus = 'idle' | 'checking' | 'refreshing' | 'connected' | 'required' | 'error'
export type GoogleDriveConsentReason = 'account' | 'pronunciation'

interface GoogleDriveConsentState {
  open: boolean
  reason: GoogleDriveConsentReason
}

export interface GoogleDriveState {
  initialized: boolean
  status: GoogleDriveConnectionStatus
  connectedEmail: string | null
  consent: GoogleDriveConsentState
}

const initialState: GoogleDriveState = {
  initialized: false,
  status: 'idle',
  connectedEmail: null,
  consent: { open: false, reason: 'account' },
}

export const googleDriveSlice = createSlice({
  name: 'googleDrive',
  initialState,
  reducers: {
    stateChanged: (state, action: PayloadAction<Partial<Omit<GoogleDriveState, 'consent'>>>) => {
      Object.assign(state, action.payload)
    },
    consentRequested: (state, action: PayloadAction<GoogleDriveConsentReason>) => {
      state.consent = { open: true, reason: action.payload }
    },
    consentDismissed: (state) => {
      state.consent.open = false
    },
    reset: () => initialState,
  },
})

export const googleDriveActions = googleDriveSlice.actions
